import { useQuery } from 'react-query';
import axios from '../../../api';

// GET request to poll preview status for one or more jobIds

const pollPreviewSurveysStatus = async ({ queryKey: [key, { wevoId, jobIds }] }) => {
  if (!wevoId || !jobIds) {
    return {};
  }

  //jobIds is an array, we join it by comma to match the query param format
  const joinedJobIds = Array.isArray(jobIds) ? jobIds.join(',') : jobIds;

  const response = await axios({
    url: `/api/v3/wevos/${wevoId}/previews/status?jobIds=${joinedJobIds}`,
    method: 'GET',
  });
  return response?.data;
};

export default function usePollPreviewSurveysStatus({ wevoId, jobIds }, options) {
  return useQuery(['previewSurveysStatus', { wevoId, jobIds }], pollPreviewSurveysStatus, options);
}
